import EventEmitter from 'eventemitter3';

let ObserverAnim = new EventEmitter();

let GLOBAL_EVENT_ANIM = {
    OPEN_ATLAS_IMPORT_MODAL: 'OPEN_ATLAS_IMPORT_MODAL',
    EDIT_ANIM_NAME: 'EDIT_ANIM_NAME',

    // Eventos del render de animación
    RENDER: {
        IMPORT_ATLAS: 'IMPORT_ATLAS',
        SET_ZOOM: 'SET_ZOOM',
        CHANGE_OR_CREATE_ANIMATION_CONTAINER: 'CHANGE_OR_CREATE_ANIMATION_CONTAINER',
        ADD_OR_REMOVE_FRAME_TO_ANIMATION_CONTAINER: 'ADD_OR_REMOVE_FRAME_TO_ANIMATION_CONTAINER',
        UPDATE_FRAMES: 'UPDATE_FRAMES',
    },
    PLAY_STOP_CONTROL: 'PLAY_STOP_CONTROL',
    NOTIFICATION_SYSTEM: {
        WARNING: 'WARNING',
        ERROR: 'ERROR',
        CLEAR: 'CLEAR'
    },
    RESET_ALL: 'RESET_ALL'
};

export {
    ObserverAnim,
    GLOBAL_EVENT_ANIM
};